// extracted by css-extract-rspack-plugin
export default {"filtersDropHeader":"filters-drop-header--V0fl8jQoOQ0pNBb2","filtersDrop":"filters-drop--I7T1JmvbywMwqmUD"};